import attendanceGallery from '@/api/report/attendance-gallery'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  orgChartStructures: [],
  employees: [],
  filters: {
    date_from: moment().format('DD-MM-YYYY'),
    date_to: moment().format('DD-MM-YYYY'),
    org_chart_structure_id: null,
    employee_id: []
  }
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  
  SET_ORG_CHART_STRUCTURE(state, data) {
    state.orgChartStructures = data
  },
  
  CLEAR_EMPLOYEE(state) {
    state.employees = []
  },
  
  SET_EMPLOYEE(state, data) {
    state.employees = data
  },
  
  SET_FILTERS(state, filters) {
    state.filters = { ...state.filters, ...filters }
  },
  
  RESET_STATE(state) {
    state.orgChartStructures = []
    state.employees = []
    state.filters = {
      date_from: moment().format('DD-MM-YYYY'),
      date_to: moment().format('DD-MM-YYYY'),
      org_chart_structure_id: null,
      employee_id: []
    }
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = {
      date_from: context.state.filters.date_from,
      date_to: context.state.filters.date_to,
      org_chart_structure_id: context.state.filters.org_chart_structure_id,
      employee_id: context.state.filters.employee_id,
      ...attributes
    }
    
    return attendanceGallery.get({ params }).then(response => {
      return Promise.resolve(response.data)
    })
  },

  async getOrgChartStructure(context, attributes = {}) {
    let response = await attendanceGallery.orgChartStructure({
      params: attributes
    })
    context.commit('SET_ORG_CHART_STRUCTURE', response.data)
  },
  
  async clearEmployee(context) {
    context.commit('CLEAR_EMPLOYEE')
  },
  
  async getEmployee(context, { id }) {
    let response = await attendanceGallery.employee(id)
    context.commit('SET_EMPLOYEE', response.data)
  },
  
  setFilters(context, filters) {
    context.commit('SET_FILTERS', filters)
  }
}
